import React from 'react';
import { Link } from 'gatsby';

import { Section } from '..';

import chest from './assets/chest.png';
import secretLab from './assets/secretLab.png';

import style from './BrowseWebGamesSection.module.less';

export const BrowseWebGamesSection = () => (
  <Section className={style.ourGames} alternate={true}>
    <h1 id="ourGames">Web Games</h1>
    <div className={style.row}>
      <div className={style.game}>
        <div className={style.gameLogoWrapper}>
          <img src={chest} alt="Unboxing the mind of a Cryptic Killer - Game Logo" className={style.gameLogo} />
        </div>
        <h2><Link to="/web-games/unboxing-the-mind-of-a-cryptic-killer">Unboxing the mind of a Cryptic Killer</Link></h2>
        <div className={style.description}>
          <p>Do you have what it takes to catch a killer? The stakes are higher than ever in this two-player cooperative puzzle adventure. A lead in a decade-old cold case turns dangerous when a familiar foe returns.</p>
          <p>To escape you must collaborate your way through the Cryptic Killer's puzzles.</p>
        </div>
        <div className={style.learnMoreWrapper}>
          <Link className={style.learnMore} to="/web-games/unboxing-the-mind-of-a-cryptic-killer">Learn more →</Link>
        </div>
      </div>
    </div>
    <div className={style.row}>
      <div className={style.game}>
        <div className={style.gameLogoWrapper}>
          <img src={secretLab} alt="Parallel Lab - Game Logo" className={style.gameLogo} />
        </div>
        <h2><Link to="/web-games/parallel-lab">Parallel Lab</Link></h2>
        <div className={style.description}>
          <p>Cooperation is key in this two-player escape room game. Communicate carefully and solve a series of twisted puzzles set by the devious "Cryptic Killer"... But no problem for two seasoned detectives like you, right?! Beat the clock, beat your captor and ESCAPE THE LAB.</p>
          <p>But hurry, time's ticking…</p>
        </div>
        <div className={style.learnMoreWrapper}>
          <Link className={style.learnMore} to="/web-games/parallel-lab">Learn more →</Link>
        </div>
      </div>
    </div>
  </Section>
);
